/** Valores REST según API_SWATID.md — el backend traduce a MQTT */

export const SWATID_MODES = ['manual', 'local', 'remota'] as const;
export type SwatidOperationMode = (typeof SWATID_MODES)[number];

export const SWATID_RELAY_ACTIONS = ['on', 'off', 'cancel'] as const;
export type SwatidRelayAction = (typeof SWATID_RELAY_ACTIONS)[number];

export const SWATID_RELAY_CONFIG_MODES = ['fijo', 'temporizado'] as const;
export type SwatidRelayConfigMode = (typeof SWATID_RELAY_CONFIG_MODES)[number];

export const SWATID_DAYS = [
  'lunes',
  'martes',
  'miercoles',
  'jueves',
  'viernes',
  'sabado',
  'domingo',
] as const;
export type SwatidDayName = (typeof SWATID_DAYS)[number];

export const SWATID_RELAY_COUNT = 16;
export const SWATID_MAX_SLOTS_PER_DAY = 5;
export const SWATID_VALID_MINUTES = [0, 15, 30, 45] as const;

export const SWATID_MODE_LABELS: Record<SwatidOperationMode, string> = {
  manual: 'Manual',
  local: 'Local',
  remota: 'Remota',
};

export const SWATID_DAY_LABELS: Record<SwatidDayName, string> = {
  lunes: 'Lunes',
  martes: 'Martes',
  miercoles: 'Miércoles',
  jueves: 'Jueves',
  viernes: 'Viernes',
  sabado: 'Sábado',
  domingo: 'Domingo',
};

export const SWATID_EVENT_TYPES = [
  'RELAY_COMMAND_STARTED',
  'RELAY_COMMAND_COMPLETED',
  'RELAY_COMMAND_CANCELLED',
  'MODE_CHANGED',
  'SCHEDULE_SET',
  'SCHEDULE_DELETED',
] as const;

export const SWATID_EVENT_LABELS: Record<string, string> = {
  RELAY_COMMAND_STARTED: 'Relé encendido',
  RELAY_COMMAND_COMPLETED: 'Relé apagado',
  RELAY_COMMAND_CANCELLED: 'Comando cancelado',
  MODE_CHANGED: 'Cambio de modo',
  SCHEDULE_SET: 'Programación configurada',
  SCHEDULE_DELETED: 'Programación eliminada',
};

/** Tolerancia en minutos al contrastar eventos con ventanas de programación */
export const SWATID_SCHEDULE_MATCH_TOLERANCE_MIN = 5;

/** Eventos por página en el historial SWATID */
export const SWATID_EVENTS_PAGE_SIZE = 20;
